import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        if (globals.debug) console.log("event-esc-key initialized");

        $(window).on("keyup", function (_e) {
            if (_e.key == "Escape") {
                window.dispatchEvent(new CustomEvent("escKey"));
            }
        });
    });
})();

export default component;
